var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 512 512",
    style: {
      color: "grey"
    },
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-full w-full",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    rx: 30,
    fill: "transparent",
    stroke: "transparent",
    strokeWidth: 0,
    strokeOpacity: "100%",
    paintOrder: "stroke"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 32 32",
    fill: "#fff",
    x: 6,
    y: 6,
    role: "img",
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 30a8 8 0 1 1 8-8a8 8 0 0 1-8 8Zm0-14a6 6 0 1 0 6 6a6 6 0 0 0-6-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.59 25L20 22.41V18h2v3.59l2 2L22.59 25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28 6a2 2 0 0 0-2-2h-4V2h-2v2h-8V2h-2v2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4v-2H6V6h4v2h2V6h8v2h2V6h4v6h2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.183679cbcb4fa994f1fbc071286832a5.svg";
export { ForwardRef as ReactComponent };